import { render, staticRenderFns } from "./TodoTask.vue?vue&type=template&id=559c608c&scoped=true"
import script from "./TodoTask.vue?vue&type=script&lang=js"
export * from "./TodoTask.vue?vue&type=script&lang=js"
import style0 from "./TodoTask.vue?vue&type=style&index=0&id=559c608c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c608c",
  null
  
)

export default component.exports